import React from 'react'
import reactjslogo from "../../react_logo.png"

const ReactJS = () => {
    return (
        <div style={{minHeight: 120}}>
            <div >
                <div className="card card-body" style={{width: 300}}>
                    <article >
                        <img  src={reactjslogo} alt=""/>
                    </article>
                This is some placeholder content for a horizontal collapse. It's hidden by default and shown when triggered.
                </div>
            </div>
        </div>
    )
}

export default ReactJS;
